import { render, staticRenderFns } from "./CompanyVendors.vue?vue&type=template&id=731e2852&scoped=true"
import script from "./CompanyVendors.vue?vue&type=script&lang=js"
export * from "./CompanyVendors.vue?vue&type=script&lang=js"
import style0 from "./CompanyVendors.vue?vue&type=style&index=0&id=731e2852&prod&scoped=true&lang=css"
import style1 from "./CompanyVendors.vue?vue&type=style&index=1&id=731e2852&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731e2852",
  null
  
)

export default component.exports